
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import BlogGenerator from '@/components/blog/BlogGenerator';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { ArrowLeftIcon } from 'lucide-react';

interface AdminContentTabProps {
  onBlogGenerated: (content: string, topic: string, keywords: string) => void;
  generatedContent: string;
  blogTitle: string;
  blogKeywords: string;
}

const AdminContentTab: React.FC<AdminContentTabProps> = ({
  onBlogGenerated,
  generatedContent,
  blogTitle,
  blogKeywords
}) => {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold mb-2">Content Management</h2>
          <p className="text-gray-600">Generate and manage blog content for your website</p>
        </div>
      </div>

      <Tabs defaultValue="generator" className="mt-4">
        <TabsList className="mb-6">
          <TabsTrigger value="generator">Generator</TabsTrigger>
          <TabsTrigger value="preview" disabled={!generatedContent}>Preview</TabsTrigger>
        </TabsList>
        
        <TabsContent value="generator">
          <BlogGenerator onBlogGenerated={onBlogGenerated} />
        </TabsContent>
        
        <TabsContent value="preview">
          {generatedContent && (
            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="mb-6">
                <h2 className="text-xl font-bold mb-2">Blog Title</h2>
                <p className="text-gray-800">{blogTitle}</p>
              </div>
              
              <div className="mb-6">
                <h2 className="text-xl font-bold mb-2">Keywords</h2>
                <p className="text-gray-800">{blogKeywords}</p>
              </div>
              
              <Separator className="my-6" />
              
              <h2 className="text-xl font-bold mb-6">Preview Content</h2>
              <div className="prose prose-lg max-w-none">
                <div dangerouslySetInnerHTML={{ __html: generatedContent }} />
              </div>
              
              <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-end">
                <Button variant="outline" className="w-full sm:w-auto">
                  Copy to Clipboard
                </Button>
                <Button variant="default" className="w-full sm:w-auto">
                  Save as Draft
                </Button>
              </div>
            </div>
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminContentTab;
